import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import SaveButton from '../../../common/buttons/SaveButton/SaveButton';
import { removeSavedJob, saveJob } from '../../../../actions/jobs';
import ShareButton from '../../../common/buttons/ShareButton/ShareButton';
import { createLinkForSharingJob, getSerializedSearchParams } from '../../../../utils/helpers';
import MainButton from '../../../common/buttons/MainButton';
import { buttonVariants } from '../../../common/buttons/types';

import { subTabs, tabs } from '../../../../Routes/jobs/jobTabs';
import { saveCurrentJob, unsaveCurrentJob } from '../../../../actions/job';

const ButtonsPanel = ({ fullJob = false, job, isSaved, isApplied, isOpen, isSaving }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const applyHandler = (id) => {
    localStorage.setItem(`OpenedJobId`, JSON.stringify(id));
    setSearchParams({ ...getSerializedSearchParams(), action: 'apply' });
  };

  return (
    <>
      {isOpen && (
        <MainButton
          rounded
          variant={isApplied ? buttonVariants.DISABLED : buttonVariants.SECONDARY}
          disabled={isApplied}
          action={() => {
            applyHandler(job?.Id);
          }}
          forceWidth="99px"
        >
          {isApplied ? t('common.general.applied') : t('common.general.apply')}
        </MainButton>
      )}
      <SaveButton
        isSaved={isSaved}
        saving={isSaving}
        id={job.Id}
        saveDispatcher={fullJob ? saveCurrentJob : saveJob}
        unsaveDispatcher={fullJob ? unsaveCurrentJob : removeSavedJob}
        withDeleting={searchParams.get('subTab') === subTabs.SAVED && searchParams.get('tab') === tabs.MY_JOBS}
      />
      <ShareButton
        title={job?.JobTitle}
        text={job?.JobDescription}
        url={createLinkForSharingJob(window.location.origin, job.Id)}
      />
    </>
  );
};

export default ButtonsPanel;
